<template>
  <div>
      <CCardHeader class="p-1">
          <CRow>
              <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

                  <strong >{{ $t('ItemsReturn') }}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
<!--                  <CButton @click="confirm_dialog()" type="submit" size="sm" color="secondary">-->
<!--                      {{ $t('changeStatus') }}-->
<!--                  </CButton>-->
              </CCol>
          </CRow>
      </CCardHeader>
    <CRow>
<!--      <CCol col="3">-->
<!--        <CSelect-->
<!--            :label="$t('inventory')"-->
<!--            horizontal-->
<!--            :value.sync="selected_place"-->
<!--            :options="place_items"-->
<!--        />-->
<!--      </CCol>-->

    </CRow>
    <CRow>
        <CCol col="3">
            <CSelect
                    :label="$t('documentType')"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                    :value.sync="selected_type"
                    :options="type_items"
            />
        </CCol>
      <CCol col="3">
        <date-picker
            :label="$t('components.startDate')"
            v-model="start_date"></date-picker>
      </CCol>
      <CCol col="3">
        <date-picker
            :label="$t('components.endDate')"
            v-model="end_date"></date-picker>

      </CCol>

        <CCol col="2">
            <CInput
                    :placeholder="$t('search')"
                    v-model="search_model"
            />
        </CCol>
        <CCol col="1">
        <CButton @click="get_damage_products" color="dark"
                 size="sm">
          <CIcon size="sm" name="cil-zoom"/>
        </CButton>
      </CCol>
    </CRow>

<CRow class="mb-5">
    <CCol>
        <CDataTableFixed
                :items="damage_items"
                :fields="damage_fields_buy"
                striped
                border
                height="300px"
                v-if="selected_type!=4"

                sorter
                column-filter
                :items-per-page="200"
                hover
                pagination
        >


            <template #row="{item,index}">

                <td>
                    <p class="text-center">
                        {{index+1}}
                    </p>

                </td>

            </template>
            <template #docDate="{item,index}">

                <td>
                    <p class="text-center">
                        {{get_date(item.docDate)}}
                    </p>

                </td>

            </template>
            <template #message="{item}">

                <td>
                    <p class="text-center">
                        {{item.message}}
                    </p>
                </td>

            </template>
            <template #qty="{item}">
                <td>
                    <p class="text-right">
                        {{Math.abs(item.qty)}}
                    </p>
                </td>
            </template>
            <template #productCode="{item}">
                <td>
                    <p style="text-align: center" v-if="item.productCode" >
                        {{ item.productCode }}
                    </p>
                </td>
            </template>

            <template #docNo="{item}">
                <td style="text-align: center">
                    <a v-if="item.docNo!=null" href="javascript:void(0)" class="text-primary" v-on:click="goToDocuments(item.refId)">
                        {{ item.docNo }}
                    </a>
                </td>
            </template>

            <template #description="{item}">
                <td>
                    <CSelect  :value.sync="item.selected_message" :options="refer_messages"/>
                </td>
            </template>
            <template #select-header="{item}">
                <input type="checkbox" v-model="check_all_exit"
                />
            </template>
            <template #select="{item}">
                <td>
                    <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                           :value="item.productId"/>
                </td>
            </template>

            <template #under-table="{item}">
                <CRow>
                    <CCol></CCol>
                    <CCol></CCol>
                    <CCol></CCol>
                    <CCol>
                        {{ $t('SumQty') }} : {{ get_currency(Math.abs(calculate_items(damage_items, "qty")) ) }}
                    </CCol>
                    <CCol></CCol>
                </CRow>
            </template>
        </CDataTableFixed>
        <CDataTableFixed
                :items="damage_items"
                :fields="damage_fields_sell"
                striped
                border
                height="300px"
v-if="selected_type==4"
                sorter
                column-filter
                :items-per-page="200"
                hover
                pagination
        >


            <template #row="{item,index}">

                <td>
                    <p class="text-center">
                        {{index+1}}
                    </p>

                </td>

            </template>
            <template #docDate="{item,index}">

                <td>
                    <p class="text-center">
                        {{get_date(item.docDate)}}
                    </p>

                </td>

            </template>
            <template #message="{item}">

                <td>
                    <p class="text-center">
                        {{item.message}}
                    </p>
                </td>

            </template>
            <template #qty="{item}">
                <td>
                    <p class="text-right">
                        {{Math.abs(item.qty)}}
                    </p>
                </td>
            </template>
            <template #productCode="{item}">
                <td>
                    <p style="text-align: center" v-if="item.productCode" >
                        {{ item.productCode }}
                    </p>
                </td>
            </template>

            <template #docNo="{item}">
                <td style="text-align: center">
                    <a v-if="item.docNo!=null" href="javascript:void(0)" class="text-primary" v-on:click="goToDocuments(item.refId)">
                        {{ item.docNo }}
                    </a>
                </td>
            </template>

            <template #description="{item}">
                <td>
                    <CSelect  :value.sync="item.selected_message" :options="refer_messages"/>
                </td>
            </template>
            <template #select-header="{item}">
                <input type="checkbox" v-model="check_all_exit"
                />
            </template>
            <template #select="{item}">
                <td>
                    <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                           :value="item.productId"/>
                </td>
            </template>

            <template #under-table="{item}">
                <CRow>
                    <CCol></CCol>
                    <CCol></CCol>
                    <CCol></CCol>
                    <CCol>
                        {{ $t('SumQty') }} : {{ get_currency(Math.abs(calculate_items(damage_items, "qty")) ) }}
                    </CCol>
                    <CCol></CCol>
                </CRow>
            </template>
        </CDataTableFixed>

    </CCol>

</CRow>

    <CModal
            :show.sync="change_status_modal"
            :no-close-on-backdrop="true"
            color="transparent"
            border-color="primary"
            size="sm"
            :title="$t('components.changeStatus')"
    >

      <CRow>
        <CCol col="12">
          <CSelect
                  :label="$t('inventory')"
                  :options="place_items"
                   :value.sync="selected_place"/>

        </CCol>
      </CRow>
      <template #footer>
        <CButton @click="return_items()"
                 color="success"
        >{{ $t("buttons.ok") }}
        </CButton>
        <CButton
                @click="change_status_modal = false"
                color="danger"
        >{{ $t("buttons.cancel") }}
        </CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import moment from 'moment-jalaali'

var items = [];
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
export default {
  name: 'Login',
  components: {
    Treeselect,

  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      place_items: [],
selected_place:0,
        search_model:'',
      change_status_modal:false,
      start_date: '',
      end_date: '',
      selected_factor: {},
      search_factor_text: null,
      selected_factors_for_status: [],
      selected_status: 0,
      status_list: [{label: this.$t('select'), value: 0}, {label: this.$t('inDriver'), value: 25}],
      // 23	ارجاع	10
      // 24	کالاها آماده ارسال	10
      // 25	تحویل سفیر	10
      // 26	در دست سفیر	10
      // 27	در مسیر تحویل	10
      // 28	تحویل شد	10
      change_status_summary: '',
      id_checkbox_items: [],
      selected_type: 4,
      type_items: [
        {label: this.$t('components.buyRet'), value: 2},
        {label: this.$t('components.sellRet'), value: 4},
        {label: this.$t('buyCurrencyRet'), value: 8},

      ],
      damage_items: [],
      damage_fields_buy: [
        {key: 'row', label: this.$t('tables.row'), _style: 'width:3%'},
        {key: 'docDate', label: this.$t('docDate'), _style: 'width:10%'},
        {key: 'productCode', label: this.$t('components.itemCode'), _style: 'width:10%'},
        {key: 'productName', label: this.$t('item'), _style: 'width:30%'},
        // {key: 'docNo', label: this.$t('referenceNo'), _style: 'width:10%'},

        {key: 'qty', label: this.$t('returnQty'), _style: 'width:10%'},
        {key: 'message', label: this.$t('description'), _style: 'width:10%'},
        {key: 'salesPerson', label: this.$t('SalesPerson'), _style: 'width:10%'},
        // {key: 'select', label: this.$t('retDesc'), _style: 'width:5%'},
        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],
        damage_fields_sell: [
        {key: 'row', label: this.$t('tables.row'), _style: 'width:3%'},
        {key: 'docDate', label: this.$t('docDate'), _style: 'width:10%'},
        {key: 'productCode', label: this.$t('components.itemCode'), _style: 'width:10%'},
        {key: 'productName', label: this.$t('item'), _style: 'width:30%'},
        // {key: 'docNo', label: this.$t('referenceNo'), _style: 'width:10%'},

        {key: 'qty', label: this.$t('returnQty'), _style: 'width:10%'},
        {key: 'message', label: this.$t('description'), _style: 'width:10%'},
        {key: 'salesPerson', label: this.$t('SalesPerson'), _style: 'width:10%'},
        {key: 'city', label: this.$t('tables.city'), _style: 'width:10%'},
        // {key: 'select', label: this.$t('retDesc'), _style: 'width:5%'},
        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],
      status_form: 0,
      refer_messages: [],
      selected_factor_id: 0,
      check_all_exit: false,
      normalizer_factors(node) {
        return {
          id: node.recId,
          label: node.masterCode + " " + node.partyName,
        }
      },
    }
  },
  mounted() {
    if(this.get_access("return_no_reference")){
      this.type_items.push( {label: this.$t('buyReturnWithoutResource'), value: 11})
      this.type_items.push( {label: this.$t('saleReturnWithoutResource'), value: 12})
    }
    this.start_date = this.get_today();
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];
this.get_places()
    this.get_messages();
    bus.$on("return_doc_added", (data) => {
        this.get_all_data();
    });
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.return_items();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {

    'start_date': function () {
      // this.get_all_data();
    },
    'end_date': function () {
      // this.get_all_data();
    },
    'selected_type': function () {
      this.search_factor_text=null;
      this.transfer_product_inventory_items= [];
      this.selected_factor= {};
    },
    'check_all_exit': function () {
      if (this.check_all_exit) {
        this.id_checkbox_items = [];

        this.damage_items.forEach((val) => {
          this.id_checkbox_items.push(val.productId);
        });
      } else {
        this.id_checkbox_items = [];
      }
    },

  },
  methods: {
    get_places() {
      var self = this;

      const formData = new FormData();

      axios.post('GetPlaces', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.place_items = [];
          self.place_items = self.sort_array(
                  self.place_items, content_data.data,
                  'id','placeName');
          self.place_items = self.place_items.filter(x=>x.natureId==4);
          self.selected_place = self.place_items[0].value
          self.get_all_data();

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }
      }).catch(function (error) {
                console.log(error);
              });
    },
    load_factors({action, searchQuery, callback}) {
      var self = this;

      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options;
          var self = this;


          const formData = new FormData();

          var url = "GetDocsByParams";
          formData.append("docType", this.selected_type);
          formData.append("PersonId", 0);

          // formData.append("id", 3);
          formData.append("SearchTxt", searchQuery);
          formData.append("FirstDate", self.start_date);
          formData.append("SecondDate", self.end_date);

          axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {

              options = response.data.data;

              callback(null, options);

            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
            }

          })
              .catch(function (error) {

                console.log(error);
              });
        })
      }
    },
    select_factor(node) {
      console.log("node ", node)
      this.factor_party_name = node.partyName;
      this.factor_date = this.get_date(node.createdAt)
      this.selected_factor_id = node.recId;
      this.selected_factor = node;
      if(node.statusId==0){
this.$root.modal_component.show_validate_errors([this.$t('documentIsNotFinalize')])
      }else{
        this.get_document_details();

      }
    },
      goToDocuments(item) {
              window.open('/dashboard/documents/show/' + item)
      },
    get_damage_products() {
      var self = this;

this.id_checkbox_items = [];
      const formData = new FormData();

      var url = "GetDamageProducts";
      formData.append("FromDate",this.start_date);
      formData.append("ToDate", this.end_date);
      formData.append("DocTypeId", this.selected_type);
      formData.append("SrchTxt", this.search_model);
      // formData.append("id", this.selected_factor_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.damage_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_messages() {
      var self = this;
      const formData = new FormData();

      var url = "GetFactorReferMessages";

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.refer_messages = self.sort_array([],content_data.data,"id",'title');


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);
        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    check_all() {
      console.log('check all clicked');
    },
    goShowDocument(item) {

      this.$router.push({path: '/dashboard/documents/show/' + item.recId});
    },


    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' && this.color != '') {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      if (this.color == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertColor'));
      }
      // if (this.description == '') {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertSummary'));
      // }
      return false;
      // e.preventDefault();
    },

    get_all_data() {
      this.get_damage_products();
      // this.get_exit_products();
      // this.get_insite_lists()
      // this.get_delivery_lists()
    },
    get_image_file(item) {
      // console.log("image url is " + item.imageName);
      return this.$root.base_url + item.imageName;
    },
    edit_item(item) {
      // this.$set(this.items[item.row_id], '_toggled', !item._toggled)
      this.name = this.items[item.row_id].catTitle;
      this.color = this.items[item.row_id].color;
      this.code = item.code;
      this.description = this.items[item.row_id].summary;
      this.previewImage = this.items[item.row_id].image;
      this.status_form = this.items[item.row_id].recId;
      setTimeout(() =>
              this.$refs.add_container.scrollIntoView()
          , 500);
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.row_id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '/img/placeholder.png';
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },

    goSubCategories(item, index) {

      this.$router.push({path: '/dashboard/base/categories/' + this.items[index].recId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    goToProductList(item) {
      this.$router.push({path: "/dashboard/products/list-cat/" + item.recId})
      // this.$router.push({ path: '/dashboard/base/categories/'+this.items[index].recId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    handleFileUpload(files, e) {
      this.file = e.target.files[0];
      this.previewImage = URL.createObjectURL(this.file);
    },
    insert_data() {


      if (!this.validateForm()) {
        // console.log("validate form is false"+this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddMainCat";
      } else {
        url = "EditMainCat";
        formData.append('id', this.status_form)

      }

      formData.append('file', this.file);
      formData.append('MainCatTitle', this.name);
      formData.append('Color', this.color);
      formData.append('Code', this.code);
      if (this.$route.params.cat_id != null) {
        formData.append('IsParent', this.$route.params.cat_id);

      } else {
        formData.append('IsParent', 0);

      }
      formData.append('summary', this.description);
      axios.post(url, formData, {}).then((res) => {



        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.name = '';
        self.color = '#ffffff';
        self.code = '';
        self.description = '';
        self.previewImage = '/img/placeholder.png';
        self.get_all_data();


      })

          // axios.post(  '/admin/category', {
          //     name: self.name,
          //     description: self.description,
          //     image: self.image,
          //     cat: 0,
          // }).then(function (response) {
          //     self.name = '';
          //     self.description = '';
          //     // localStorage.setItem("api_token", response.data.access_token);
          //     // self.$router.push({ path: 'notes' });
          // })
          .catch(function (error) {
            console.log(error);
          });

    },
    confirm_dialog() {
      if(this.id_checkbox_items.length==0){
this.$root.modal_component.show_validate_errors([this.$t('selectOneProduct')])
        return false;
      }
      // this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("sureToReturn"), [this.$t("dialogs.ok")], this.confirm_delete_name);
      this.change_status_modal = true;

    },
    return_items() {

      let self = this;
      const formData = new FormData()
      let url;
      url = "AddFactorReturn";


      formData.append('BaseFactorId', this.search_factor_text);
      formData.append('PlaceId', this.selected_place);
      formData.append('DocTypeId', this.selected_type+1);
      var details = [];
      for(var i=0;i<this.id_checkbox_items.length;i++){

        details.push({
          DetailId: this.id_checkbox_items[i],
          MasterId: this.search_factor_text,
          ProductId:this.damage_items.filter(x=>x.productId==this.id_checkbox_items[i])[0].productId,
          Qty:this.damage_items.filter(x=>x.productId==this.id_checkbox_items[i])[0].retQty,
        RetMessageId:"",
                })
      }

      formData.append('Details', JSON.stringify(details));

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.search_factor_text=null;
        self.transfer_product_inventory_items= [];
        self.selected_factor= {};

      })
              .catch(function (error) {

                console.log(error);
              });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
